<template>
    <div id="campus-folder"></div>
</template>

<script>
export default {
    name: 'PDFViewer',
    props: {
        pdfUrl: {
            type: String,
            default: null,
        },
    },
    mounted() {
        let PDFObject = require('pdfobject');
        PDFObject.embed(this.pdfUrl, '#campus-folder');
    },
};
</script>

<style scoped>

</style>
